const showroomsRouter = [
    {
        path: "list-showrooms",
        name: "list",
        component: () => import("@/views/admin/showrooms"),
        default: true,
        meta: {
            model: "showrooms",
            // requiresAuth: true,
        },
    },
    {
        path: "list-showrooms/add",
        name: "add",
        component: () => import("@/views/admin/showrooms/function"),
        default: true,
        meta: {
            model: "showrooms",
            // requiresAuth: true,
        },
    },
    {
        path: "list-showrooms/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/showrooms/function"),
        default: true,
        meta: {
            model: "showrooms",
            // requiresAuth: true,
        },
    },
  ];
  export default showroomsRouter;